import { render } from "./fountain-section.vue?vue&type=template&id=64377c56"
import script from "./fountain-section.vue?vue&type=script&lang=js"
export * from "./fountain-section.vue?vue&type=script&lang=js"

import "./fountain-section.vue?vue&type=style&index=0&id=64377c56&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__